module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.unfold) ? _c('div', {
    staticClass: "content-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeUnfold()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/home/help.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.unfold) ? _c('div', {
    staticClass: "content-right-unfold",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeUnfold()
      }
    }
  }, [_c('div', {
    staticClass: "content-right-unfold-text"
  }, [_vm._v("咨询请添加爱丁")]), _vm._v(" "), _c('div', {
    staticClass: "content-right-unfold-name"
  }, [_vm._v("王老师")]), _vm._v(" "), _c('img', {
    staticClass: "content-right-unfold-qrcode",
    attrs: {
      "src": require("../../assets/images/home/qrcode.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right-unfold-other"
  }, [_vm._v("( 除非法定节假日， 工作日都在线~ )")]), _vm._v(" "), _c('img', {
    staticClass: "content-right-unfold-luti",
    attrs: {
      "src": require("../../assets/images/home/luti.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toBank()
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/home/unfold-help.png")
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0983fa26"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/help.vue
// module id = 545
// module chunks = 93